import React, { useState } from "react";
import {
  ChakraProvider,
  Box,
  Text,
  VStack,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Grid,
  IconButton,
  Tooltip,
  Button,
  Input,
  Textarea,
  Icon,
  useToast,
  Divider,
  Modal ,
  ModalOverlay ,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter

} from "@chakra-ui/react";
import DraggableTextCreationElement from "./components/questionCreationComponents/DraggableTextCreationElement";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DraggableRatingCreationElement from "./components/questionCreationComponents/DraggableRatingCreationElement";
import DraggableCommentCreationElement from "./components/questionCreationComponents/DraggableCommentCreationElement";
import DraggableRankingDropdownRadiogroupCheckboxCreationElement from "./components/questionCreationComponents/DraggableDropdownRadiogroupCheckboxCreationelement";
import { ChatIcon, StarIcon, QuestionIcon, RepeatIcon } from "@chakra-ui/icons";
import { v4 as uuidv4 } from "uuid";
import { MdArrowDropDown } from "react-icons/md";
import { FaRegComment } from "react-icons/fa";
import { PiRadioButtonDuotone } from "react-icons/pi";
import { RiCheckboxMultipleFill } from "react-icons/ri";
import DraggableBooleanCreationElement from "./components/questionCreationComponents/DraggableBooleanCreationElement";
import { VscSymbolBoolean } from "react-icons/vsc";
import DraggableMatrixCreationElement from "./components/questionCreationComponents/DraggableMatrixCreationelement";
import { PiMatrixLogoFill } from "react-icons/pi";
import { MdOutlineSaveAs } from "react-icons/md";
import { ViewIcon, ArrowBackIcon } from "@chakra-ui/icons";
import DraggableMatrixDropdownCreationElement from "./components/questionCreationComponents/DraggableMatrixDropdownCreationElement";
import SurveyPreviewModal from "./SurveyPreviewModal";
import { BiMailSend } from "react-icons/bi";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SaveUpdateSurveyModal from "./SaveUpdateSurveyModal";
import { getSurveyADP } from "../../services/http/surveyHttpService";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDisclosure } from "@chakra-ui/react";
import { useExchangeData } from "./groups/ExchangeDataProvider";
import { FaRankingStar } from "react-icons/fa6";

import logout from "../../services/authService";
import createAxiosInstance from "../../interceptors/useAxiosInterceptors";
import { useSession } from "../../SessionContext";
import { initSurveyService } from "../../services/http/surveyHttpService";

function SurveyUpdateComponent() {
  const navigate = useNavigate();
  

  const { id } = useParams(); // Estrai il parametro 'id' dall'URL
  const {t} = useTranslation();
  const { 
    isOpen: isOpenModalDiscardChangesSurvey, 
    onOpen: onOpenModalDiscardChangesSurvey, 
    onClose: onCloseModalDiscardChangesSurvey 
  } = useDisclosure();  
  const {updateDataSurvey } = useExchangeData();

  const options = [ "ranking","rating", "dropdown", "radiogroup", "checkbox", "boolean", "matrix", "text", "comment"];
  const toast = useToast();
  const [isModalPreviewOpen, setModalPreviewOpen] = useState(false)

  const [isModalSaveSurveyOpen, setModalSaveSurveyOpen] = useState(false)

  const [isDraft, setIsDraft] = useState(false)

  const { updateSessionData, clearSessionData } = useSession();

  const axiosInstance = createAxiosInstance(async (axiosInstance)=> {
 
    logout(t, clearSessionData,navigate,toast,axiosInstance)
  });
 
  initSurveyService(t, toast, axiosInstance)

  const popolateSurvey = ()=> {
    if(id != null) {
      getSurveyADP({id_survey_info: id }).then(res => {
        

        if(res && res.message && res.message.survey_structure) 

        setSurvey(res.message.survey_structure)
      })    
        
    }
  }

  useEffect(() => { 
    
    popolateSurvey()

    
   
     }, []);

  const cleanSurveyState = {
    title: "",
    description: "",
    pages: [
      {
        title: "Page 1",
        elements: [],
      },
    ],
  };

  const [survey, setSurvey] = useState(cleanSurveyState);

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const addNewPage = () => {
    setSurvey((prevSurvey) => ({
      ...prevSurvey,
      pages: [
        ...prevSurvey.pages,
        { title: `Page ${prevSurvey.pages.length + 1}`, elements: [] },
      ],
    }));
    setCurrentPageIndex(survey.pages.length); // Vai alla nuova pagina
  };

  const goToNextPage = () => {
    if (currentPageIndex < survey.pages.length - 1) {
      setCurrentPageIndex(currentPageIndex + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex(currentPageIndex - 1);
    }
  };

  const removePage = (pageIndex) => {
    if (survey.pages.length > 1) {
      setSurvey((prevSurvey) => {
        const updatedPages = prevSurvey.pages.filter((_, index) => index !== pageIndex);
        const newPageIndex = pageIndex > 0 ? pageIndex - 1 : 0;
        setCurrentPageIndex(newPageIndex);
        return {
          ...prevSurvey,
          pages: updatedPages,
        };
      });
    } else {
      toast({
        title: t('toastMsg.surveyCreator.cannotDeleteLastPage'),
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
    }
  };

  const addElementToCurrentPage = (elementType) => {
    setSurvey((prevSurvey) => {
      const updatedPages = [...prevSurvey.pages];
      updatedPages[currentPageIndex].elements.push({
        type: elementType,
        id: uuidv4(),
      });
      return { ...prevSurvey, pages: updatedPages };
    });
  };

  const handleTitleChange = (e) => {
    const newTitle = e.target.value;
    setSurvey((prevSurvey) => ({ ...prevSurvey, title: newTitle }));
  };

  const handleDescriptionChange = (e) => {
    const newDescription = e.target.value;
    setSurvey((prevSurvey) => ({ ...prevSurvey, description: newDescription }));
  };

  const handlePageTitleChange = (e) => {
    const newPageTitle = e.target.value;
    setSurvey((prevSurvey) => {
      const updatedPages = [...prevSurvey.pages];
      updatedPages[currentPageIndex] = { ...updatedPages[currentPageIndex], title: newPageTitle };
      return { ...prevSurvey, pages: updatedPages };
    });
  };
  const handleCloseModal = () => {
    setModalPreviewOpen(false); // Chiude il modale
  };
  return (
    <ChakraProvider>
      <DndProvider backend={HTML5Backend}>
        <Flex height="100vh" direction="row" width="100%">
          {/* Main Content Area */}
          <MainContentArea
            survey={survey}
            setSurvey={setSurvey}
            currentPageIndex={currentPageIndex}
            addElementToCurrentPage={addElementToCurrentPage}
            handleTitleChange={handleTitleChange}
            handleDescriptionChange={handleDescriptionChange}
            onOpenModalDiscardChangesSurvey={onOpenModalDiscardChangesSurvey}
          />

          {/* Sidebar */}
          <Sidebar
           
         
            survey={survey}
            options={options}
            goToPreviousPage={goToPreviousPage}
            goToNextPage={goToNextPage}
            addNewPage={addNewPage}
            currentPageIndex={currentPageIndex}
            totalPages={survey.pages.length}
            removePage={removePage} // Passiamo la funzione removePage
            setModalPreviewOpen={setModalPreviewOpen}
            handlePageTitleChange={handlePageTitleChange}
            onOpenModalDiscardChangesSurvey={onOpenModalDiscardChangesSurvey }
            setModalSaveSurveyOpen={setModalSaveSurveyOpen}
            setIsDraft={setIsDraft}
            popolateSurvey={popolateSurvey}
           
            
          />

<SurveyPreviewModal
 isConsensus={false}
        surveyConfig={survey} // Passa la configurazione del sondaggio
        isOpen={isModalPreviewOpen} // Stato di apertura/chiusura
        onClose={handleCloseModal} // Funzione per chiudere
      />
 

      <Modal onClose={onCloseModalDiscardChangesSurvey} isOpen={isOpenModalDiscardChangesSurvey} isCentered closeOnOverlayClick={false} >
                  <ModalOverlay />
                  <ModalContent>
                    <ModalHeader>   {t('survey.confirmExitUpdateSurveyWithoutSavingMessage')} </ModalHeader>
                    <ModalBody></ModalBody>
                    <ModalFooter>
                      <Button colorScheme='green' mr={3} onClick={()=> {
                        setSurvey(cleanSurveyState);
                        setCurrentPageIndex(0);
                       navigate("/surveys?hideHeader=true&hideNavbar=true")
                      
                       
                      }}>
                         {t('survey.tableGroup.yes')}
                      </Button>
                      <Button colorScheme='red' onClick={onCloseModalDiscardChangesSurvey}>
                        No
                      </Button>
                    </ModalFooter>
                  </ModalContent>
                </Modal>

{isModalSaveSurveyOpen && (


<SaveUpdateSurveyModal
        surveyStructure={survey} // Passa la configurazione del sondaggio
        isOpen={isModalSaveSurveyOpen} // Stato di apertura/chiusura
        onClose={()=> setModalSaveSurveyOpen(false)} // Funzione per chiudere
        isDraft={isDraft}
        updateFormData={updateDataSurvey}
      />)}
        </Flex>
      </DndProvider>
    </ChakraProvider>
  );
}

function MainContentArea({ onOpenModalDiscardChangesSurvey,survey, setSurvey, addElementToCurrentPage, currentPageIndex, handleTitleChange, handleDescriptionChange }) {
  const {t} = useTranslation();
  const updatePageSurvey = (pageIndex, elementId, identifier, val) => {
    console.log(pageIndex, elementId, identifier, val)
    setSurvey((prevSurvey) => {
      const updatedPages = [...prevSurvey.pages];
      const targetPage = updatedPages[pageIndex];
      const elementIndex = targetPage.elements.findIndex((element) => element.id === elementId);
      if (elementIndex !== -1) {
        const updatedElement = {
          ...targetPage.elements[elementIndex],
          [identifier]: val,
        };
        targetPage.elements = [
          ...targetPage.elements.slice(0, elementIndex),
          updatedElement,
          ...targetPage.elements.slice(elementIndex + 1),
        ];
        updatedPages[pageIndex] = targetPage;
      }
      return {
        ...prevSurvey,
        pages: updatedPages,
      };
    });
  };

  const copyElement = (index) => {
    setSurvey((prevSurvey) => {
      const updatedPages = [...prevSurvey.pages];
      const elements = updatedPages[currentPageIndex].elements;
  
      // Crea una copia dell'elemento selezionato e assegna un nuovo id
      const elementCopy = { ...elements[index], id: uuidv4() };
  
      // Aggiunge la copia alla fine della lista degli elementi
      elements.push(elementCopy);
  
      return { ...prevSurvey, pages: updatedPages };
    });
  
    // Scorri verso la fine solo se il riferimento è disponibile
    
  };

 // Funzione di copia profonda utilizzando structuredClone con fallback
const deepClone = (obj) => (typeof structuredClone === "function" ? structuredClone(obj) : JSON.parse(JSON.stringify(obj)));

const moveElementUp = (index) => {
  setSurvey((prevSurvey) => {
    // Verifica che prevSurvey, pages e l'indice corrente siano validi
    if (!prevSurvey || !prevSurvey.pages || !prevSurvey.pages[currentPageIndex]) return prevSurvey;

    // Copia profonda delle pagine per garantire che i cambiamenti siano rilevati
    const updatedPages = deepClone(prevSurvey.pages);
    const elements = updatedPages[currentPageIndex].elements;

    // Controllo di validità per evitare di spostare un elemento già al primo posto
    if (index <= 0) return prevSurvey;

    // Rimuove l'elemento dalla posizione corrente e reinserisce una copia profonda alla posizione superiore
    const element = deepClone(elements[index]);
    elements.splice(index, 1);
    elements.splice(index - 1, 0, element);

    return { ...prevSurvey, pages: updatedPages };
  });
};

const moveElementDown = (index) => {
  setSurvey((prevSurvey) => {
    // Verifica che prevSurvey, pages e l'indice corrente siano validi
    if (!prevSurvey || !prevSurvey.pages || !prevSurvey.pages[currentPageIndex]) return prevSurvey;

    // Copia profonda delle pagine per garantire che i cambiamenti siano rilevati
    const updatedPages = deepClone(prevSurvey.pages);
    const elements = updatedPages[currentPageIndex].elements;

    // Controllo di validità per evitare di spostare un elemento già in fondo
    if (index >= elements.length - 1) return prevSurvey;

    // Rimuove l'elemento dalla posizione corrente e reinserisce una copia profonda alla posizione inferiore
    const element = deepClone(elements[index]);
    elements.splice(index, 1);
    elements.splice(index + 1, 0, element);

    return { ...prevSurvey, pages: updatedPages };
  });
};

  
  const removeElement = (index) => {
    setSurvey((prevSurvey) => {
      const updatedPages = [...prevSurvey.pages];
      const elements = updatedPages[currentPageIndex].elements;
  
      // Controlla che l'array non sia vuoto e che l'indice sia valido
      if (elements.length === 0 || index < 0 || index >= elements.length) return;
  
      // Rimuove l'elemento in base all'indice
      elements.splice(index, 1);
  
      return { ...prevSurvey, pages: updatedPages };
    });
  };
  


  const [, drop] = useDrop({
    accept: "FORM_ELEMENT",
    drop: (item) => addElementToCurrentPage(item.name),
  });

  return (
    <Flex direction="column" flex="1" height="100vh">
<Box bg="white" p={2} boxShadow="sm" zIndex="10">
  <Flex gap={2} align="center">
    <Tooltip label="GoBack" aria-label="Reset Tooltip">
        <IconButton
          icon={<ArrowBackIcon boxSize={6} />}
          colorScheme="red"
          aria-label="GoBack"
          onClick={() => {
            onOpenModalDiscardChangesSurvey()
           
             
          }}
          size="xs"
        />
      </Tooltip>
    
    {/* Survey Details Title */}
    <Text fontSize="md" fontWeight="bold" color={"rgba(11,78,90,255)"}>
      {t('survey.surveyCreation')}
    </Text>
  </Flex>
  
  {/* Flex container for inputs */}
  <Flex gap={2} align="inline" mt={2} ml={4}>
    {/* Survey Title */}


    <Box flex="1" maxW="50%">
      <Text fontSize="sm" fontWeight="bold" mb={1}>
        {t('survey.surveyTitle')}
      </Text>
      <Input
        value={survey.title}
        onChange={handleTitleChange}
        placeholder={t('survey.enterSurveyTitle')}
        fontSize="sm"
        h="7"
        px="2"
      />
    </Box>

    {/* Survey Description */}
    <Box flex="1" maxW="50%">
      <Text fontSize="sm" fontWeight="bold" mb={1}>
        {t('survey.surveyDescription')}
      </Text>
      <Textarea
        value={survey.description}
        onChange={handleDescriptionChange}
        placeholder={t('survey.enterSurveyDescription')}
        fontSize="sm"
        h="7"
        resize="none"
        px="2"
      />
    </Box>
  </Flex>
</Box>



      <Box ref={drop} flex="1" overflowY="auto" p={4} pb={16}  bgColor={"#f6f3ec"} mt={1}>
        <VStack align="start" spacing={4} width="100%" mb={4}>
          {survey.pages[currentPageIndex].elements.map((element, index) => (
            <Box
              key={element.id}
              border="1px solid"
              borderColor="gray.300"
              borderRadius="md"
              padding="4"
              width="100%"
              bg="white"
            >
              <Box mb="2" fontWeight="bold" color="gray.600">
                {t('survey.question')} {index + 1}
              </Box>


              
              {element.type === "text" && 
  <DraggableTextCreationElement 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}
{element.type === "rating" && 
  <DraggableRatingCreationElement 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}
{element.type === "comment" && 
  <DraggableCommentCreationElement 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}

{element.type === "ranking" && 
  <DraggableRankingDropdownRadiogroupCheckboxCreationElement 
    name="ranking" 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}


{element.type === "dropdown" && 
  <DraggableRankingDropdownRadiogroupCheckboxCreationElement 
    name="dropdown" 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}
{element.type === "radiogroup" && 
  <DraggableRankingDropdownRadiogroupCheckboxCreationElement 
    name="radiogroup" 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}
{element.type === "checkbox" && 
  <DraggableRankingDropdownRadiogroupCheckboxCreationElement 
    name="checkbox" 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}
{element.type === "boolean" && 
  <DraggableBooleanCreationElement 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}
{element.type === "matrix" && 
  <DraggableMatrixCreationElement 
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}


{element.type === "matrixdropdown" && 
  <DraggableMatrixDropdownCreationElement
    
    element={element} 
    onMoveUp={() => moveElementUp(index)} 
    onMoveDown={() => moveElementDown(index)} 
    onDelete={() => removeElement(index)} 
    onCopy={() => copyElement(index)} 
    onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }} 
  />
}

            </Box>
          ))}
                    
        </VStack>
      </Box>
    </Flex>
  );
}

function Sidebar({  popolateSurvey,survey, options, goToPreviousPage, goToNextPage, addNewPage, currentPageIndex, totalPages, removePage , setModalPreviewOpen ,handlePageTitleChange, setModalSaveSurveyOpen, setIsDraft}) {
  const {t} = useTranslation();
  return (
<Box
  width={{ base: "100%", md: "200px", lg: "300px" }}
  bg="gray.50"
  padding="2"
  boxShadow="xl"
  height="100vh"
  borderRadius="md"
  display="flex"
  flexDirection="column"
>
  {/* Contenuto scrollabile principale */}
  <Box
    flex="6"
    overflow="auto" /* Scroll verticale e orizzontale */
    mb={2}
  >
    {/* Primo Box responsivo */}
    <Box
      width="100%"
      minHeight="20vh"
      bg="white"
      padding={2}
      border="1px solid"
      borderColor="gray.300"
      borderRadius="md"
      boxShadow="sm"
      mb={0.5}
      overflow="auto"
    >
      <Text
        fontSize={{ base: "xs", md: "sm" }}
        fontWeight="bold"
        mb={2}
        textAlign="center"
        color="gray.800"
      >
        {t('survey.sideBar.dragNewQuestion')}
      </Text>
      <Table variant="simple" size="xs">
        <Thead>
          <Tr>
            <Th
              textAlign="center"
              color="gray.600"
              fontSize="xs"
              paddingY={1}
            >
              {t('survey.sideBar.questionTypes')}
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {options.map((option, index) => (
            <DraggableTableRow key={index} option={option} />
          ))}
        </Tbody>
      </Table>
    </Box>

    <Divider mb={0.5} width="100%" borderColor="gray.300" />

    {/* Secondo Box responsivo */}
    <Box
  width="100%"
  maxHeight={{ base: "calc(45vh - 60px)", md: "calc(35vh - 60px)",}}
  bg="white"
  padding={3}
  border="1px solid"
  borderColor="gray.300"
  borderRadius="md"
  boxShadow="sm"
  overflow="auto" /* Abilita scrolling */
>
      <Text
        fontSize={{ base: "sm", md: "md" }}
        fontWeight="bold"
        mb={0.1}
        textAlign="center"
        color="gray.800"
      >
        {t('survey.sideBar.pages')}
      </Text>
      <Text textAlign="center" mb={3} fontSize="sm">
        {t('survey.sideBar.page')} {currentPageIndex + 1} {t('survey.sideBar.of')} {totalPages}
      </Text>

      <Text fontSize="sm" fontWeight="bold" mb={2}>
        {t('survey.sideBar.pageTitle')}
      </Text>
      <Input
        value={survey.pages[currentPageIndex].title}
        onChange={handlePageTitleChange}
        placeholder={t('survey.sideBar.enterPageTitle')}
        fontSize="sm"
        mb={3}
      />

      <Button
        onClick={goToPreviousPage}
        isDisabled={currentPageIndex === 0}
        mb={2}
        size="md"
        width="100%"
      >
        {t('survey.sideBar.previousPage')}
      </Button>
      <Button
        onClick={goToNextPage}
        isDisabled={currentPageIndex === totalPages - 1}
        mb={2}
        size="md"
        width="100%"
      >
        {t('survey.sideBar.nextPage')}
      </Button>
      <Button
        onClick={addNewPage}
        size="md"
        width="100%"
        mb={2}
      >
        {t('survey.sideBar.addNewPage')}
      </Button>
      <Button
        onClick={() => removePage(currentPageIndex)}
        isDisabled={totalPages === 1}
        colorScheme="red"
        size="md"
        width="100%"
      >
        {t('survey.sideBar.removeCurrentPage')}
      </Button>
    </Box>
  </Box>

  {/* Azioni sempre visibili */}
  <Box
    bg="white"
    borderTop="1px solid"
    borderColor="gray.300"
    boxShadow="sm"
    position="sticky"
    bottom="0"
    padding={4}
    zIndex="1"
  >
    <Text
      fontSize={{ base: "sm", md: "md", lg: "lg" }}
      fontWeight="bold"
      mb={2}
      textAlign="center"
      color="gray.800"
    >
      {t('survey.sideBar.actions')}
    </Text>

    <Grid
      templateColumns="repeat(4, 1fr)"
      gap={2}
      width="100%"
      justifyItems="center"
    >




      <Tooltip label={t('survey.sideBar.saveDraft')} aria-label="Save Draft">
        <IconButton
          icon={<MdOutlineSaveAs style={{ fontSize: "1.5em" }} />}
          colorScheme="orange"
          aria-label="Update Draft"
          onClick={() => {
            setIsDraft(true);
            setModalSaveSurveyOpen(true);
          }}
          size="lg"
        />
      </Tooltip>

      <Tooltip label={t('survey.sideBar.save')} aria-label="Save Tooltip">
        <IconButton
          icon={<BiMailSend style={{ fontSize: "1.7em" }} />}
          colorScheme="blue"
          aria-label="Save"
          onClick={() => {
            setIsDraft(false);
            setModalSaveSurveyOpen(true);
          }}
          size="lg"
        />
      </Tooltip>

      <Tooltip label={t('survey.sideBar.preview')} aria-label="Preview Tooltip">
        <IconButton
          icon={<ViewIcon boxSize={6} />}
          colorScheme="green"
          aria-label="Preview"
          onClick={() => {
            setModalPreviewOpen(true);
          }}
          size="lg"
        />
      </Tooltip>


         <Tooltip label={t('toolTip.tooltipSurvey.surveyCreate.sidebar.reset')} placement="top">
              <IconButton
                icon={<RepeatIcon boxSize={6} />}
                colorScheme="red"
                aria-label="Reset"
                onClick={() => {
                  popolateSurvey()
                }}
                size="lg"
              />
            </Tooltip>

  
    </Grid>
  </Box>
</Box>


  
  
  
  );
}

function DraggableTableRow({ option }) {
  const [{ isDragging }, drag] = useDrag({
    type: "FORM_ELEMENT",
    item: { name: option },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <Tr ref={drag} opacity={isDragging ? 0.5 : 1}>
      <Th display="flex" alignItems="center">
        
        {option === "text" ? (
          
          <Icon as={ChatIcon} boxSize={5} marginRight="2" mt={4} />
        ) : option === "rating" ? (
          <Icon as={StarIcon} boxSize={5} marginRight="2" />
        ) :
        option === "comment" ? (
          <Icon as={FaRegComment} boxSize={5} marginRight="2" />
        ) :
        option === "ranking" ? (
          <Icon as={FaRankingStar} boxSize={5} marginRight="2" />
        ) :
        option === "dropdown" ? (
          <Icon as={MdArrowDropDown} boxSize={5} marginRight="2" />
        ) :
        option === "radiogroup" ? (
          <Icon as={PiRadioButtonDuotone} boxSize={5} marginRight="2" />
        ) :
        option === "checkbox" ? (
          <Icon as={RiCheckboxMultipleFill } boxSize={5} marginRight="2" />
        ) :
        option === "boolean" ? (
          <Icon as={VscSymbolBoolean } boxSize={5} marginRight="2" />
        ) :
        option === "matrix" ? (
          <Icon as={PiMatrixLogoFill } boxSize={5} marginRight="2" />
        ) :
        option === "matrixdropdown" ? (
          <Box>
          <Icon as={PiMatrixLogoFill } boxSize={5} marginRight="2" /> 
          <Icon as={MdArrowDropDown } boxSize={5} marginRight="2" />
          </Box>
        ) :
        (
          <Icon as={QuestionIcon} boxSize={5} marginRight="2" />
        )}
        {option}
      </Th>
    </Tr>
  );
}

export default SurveyUpdateComponent;
